<!-- Aktiver Zeitraum im Format "DD.MM.YYYY - DD.MM.YYYY" -->
<span class="zeitraum-text">
  {{ data().activeFrom | date:dateFormat }} - {{ data().activeUntil | date:dateFormat }}
</span>
